<script>
import { mapActions } from 'vuex';
export default {
  computed: {
    daysLeft() {
      const expired = localStorage.getItem("guest_expired");
      if (!expired) return 0;
      const diffMs = new Date(expired).getTime() - new Date().getTime();
      const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      return diffDays > 0 ? diffDays : 0;
    },
    isExpired() {
      return this.daysLeft === 0;
    }
  },
  methods: {
    getDayWord(num) {
      if (num % 10 === 1 && num % 100 !== 11) return 'день';
      if ([2,3,4].includes(num % 10) && ![12,13,14].includes(num % 100)) return 'дня';
      return 'дней';
    },
    ...mapActions(['navigateToPay']),
  }
}
</script>

<template>
  <section class="banner" v-if="$store.state.role === 'guest'">
    <div class="banner__left">
      <span class="banner__pill">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
        </svg>
        <span v-if="isExpired">Гостевой режим</span>
        <span v-else>Гостевой доступ: ещё {{ daysLeft }} {{ getDayWord(daysLeft) }}</span>
      </span>
      <h2 class="banner__title">Ваш путь к офферу - уже начался</h2>
      <p class="banner__subtitle">Осталось пройти его правильно. Куратор рядом на каждом шаге.</p>
    </div>
    <div class="banner__right">
      <button class="banner__cta" @click="navigateToPay()">Узнать свои шансы →</button>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.banner {
  background: linear-gradient(135deg, #0b2f43 0%, #11415D 70%, #185678 100%);
  color: white;
  padding: 1.25rem 1.75rem;
  border-radius: 1rem;
  display: none;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
  }

  &__left {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
  }

  &__pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 2rem;
    padding: 0.2rem 0.65rem;
    font-size: 0.75rem;
    font-weight: 500;
    width: fit-content;

    &--expired {
      background: rgba(239, 68, 68, 0.2);
      border-color: rgba(239, 68, 68, 0.45);
    }
  }

  &__title {
    font-size: min(max(17px, calc(1.0625rem + ((1vw - 7.68px) * 0.868))), 26px);
    font-weight: 700;
    margin: 0;
    line-height: 1.25;
  }

  &__subtitle {
    font-size: min(max(12px, calc(0.75rem + ((1vw - 7.68px) * 0.26))), 14px);
    opacity: 0.75;
    margin: 0;
    line-height: 1.45;
  }

  &__right {
    flex-shrink: 0;
  }

  &__cta {
    border: none;
    border-radius: 10px;
    padding: 0.7rem 1.5rem;
    background: #E53E3E;
    color: white;
    font-weight: 700;
    font-size: 0.9rem;
    cursor: pointer;
    white-space: nowrap;
    transition: opacity 0.2s ease, transform 0.2s ease;
    box-shadow: 0 4px 14px rgba(229, 62, 62, 0.4);

    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
    }
  }
}
</style>
